import { SIDE_GAP } from "./constants";
var isOutSideTop = function isOutSideTop(topPosition, topContainerPosition) {
  var gap = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : SIDE_GAP;
  return topPosition - gap < 0 || (topContainerPosition ? topContainerPosition > topPosition : false);
};
var isOutsideRight = function isOutsideRight(_ref) {
  var tooltipMessageRect = _ref.tooltipMessageRect,
    containerWidth = _ref.containerWidth,
    _ref$gap = _ref.gap,
    gap = _ref$gap === void 0 ? SIDE_GAP : _ref$gap,
    rightContainerPosition = _ref.rightContainerPosition;
  return Number(tooltipMessageRect.right) + gap > (rightContainerPosition || containerWidth);
};
var isOutSideBottom = function isOutSideBottom(_ref2) {
  var tooltipMessageRect = _ref2.tooltipMessageRect,
    containerHeight = _ref2.containerHeight,
    bottomContainerPosition = _ref2.bottomContainerPosition,
    _ref2$gap = _ref2.gap,
    gap = _ref2$gap === void 0 ? SIDE_GAP : _ref2$gap;
  return Number(tooltipMessageRect.bottom) + gap > (bottomContainerPosition || containerHeight);
};
var isOutsideLeft = function isOutsideLeft(leftPosition, leftContainerPosition) {
  var gap = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : SIDE_GAP;
  return leftPosition - gap < 0 || (leftContainerPosition ? leftPosition < leftContainerPosition : false);
};
export { isOutSideBottom, isOutSideTop, isOutsideLeft, isOutsideRight };